module.exports = __webpack_public_path__ + "static/media/farzam.de5adcfa.jpg";